import React, { useEffect, useState, useContext } from 'react';
import LoginModule from './LoginModule';
import styled from 'styled-components';
import { HTTPService, hiddoClickHOF, convertHttps } from '../util';
import { JumbotronInfo } from '../models/JumbtronsResult';
import axios from 'axios';
import { Carousel } from '@yy/tofu-ui-react';
import classNames from 'classnames';
import { LoginStatusContext } from '../App';

const Slide = styled.a<{
  bgURL: string;
}>`
  display: inline-block;
  width: 100%;
  height: 280px;
  background-size: auto 100%;
  background-position: center;
  background-repeat: no-repeat;
  ${(props: any) => props.bgURL && `background-image: url(${props.bgURL});`}
`;

const CustomIndicator = ({ ...props }) => <a {...props}>{props.children}</a>;
const StyledCustomIndicator = styled(CustomIndicator)`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.3);
  margin-right: 20px;
  cursor: pointer;
  &.active {
    background: #fff;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

const Jumbotron = () => {
  const [autoPlay, setAutoPlay] = useState(false);
  const [jumbotrons, setJumbotrons] = useState<JumbotronInfo[]>([]);
  const isLoggedIn = useContext(LoginStatusContext);

  const fetchJumbotrons = async () => {
    const { data } = await axios.get(
      '//www.yy.com/zone/guildanchor/banner.json'
    );

    let list = data?.data?.data?.list;
    if (data.code === HTTPService.Ok && list && list.length) {
      setJumbotrons(list);
      setAutoPlay(list.length > 1);
    } else {
      setAutoPlay(false);
      // 否则取默认的图
      setJumbotrons([
        { picUrl: 'https://zonemin.bs2cdn.yy.com/homepage-top-banner.png' }
      ]);
    }
  };

  useEffect(() => {
    fetchJumbotrons();

    // TODO: should cancel this request
    // return () => cancel()
  }, [isLoggedIn]);

  function renderIndicator({ index, active, setCurActive }: any) {
    return (
      <StyledCustomIndicator
        key={index}
        className={classNames('custom-indicator', {
          active
        })}
        onClick={() => {
          setCurActive(index);
        }}
      />
    );
  }

  return (
    <div className="jumbotron">
      <Carousel
        autoPlay={autoPlay}
        key={`${autoPlay}`}
        indicator={renderIndicator}
        showIndicator={autoPlay}
        duration={5000}
      >
        {jumbotrons.map((x, idx) => (
          <Slide
            key={idx}
            href={convertHttps(x.linkUrl as string)}
            target="_blank"
            bgURL={convertHttps(x.picUrl)}
            onClick={hiddoClickHOF('2')}
          />
        ))}
      </Carousel>
      <LoginModule />
    </div>
  );
};

export default Jumbotron;
